import "./TimeSheet.scss";
import { DatePicker, Select } from "antd";
import { DropDownIcon, IconCalendar, NextIcon } from "../../dashboard/assets";
import { useAuth } from "../../../authentication/authHelpers";
import TimeSheetButtonsFilter from "./TimeSheetButtonsFilter";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../utils/dayjs";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { eventTracker } from "../../../utils/eventTracker";
import { showWarningMsg } from "../../Documentation/utils/Messages";

const { Option } = Select;

function TimeSheetHeader({ activeFilter, setActiveFilter, viewType }) {
  const auth = useAuth();
  const { departments } = useSelector((state) => state.departments);
  const { activeEmployees } = useSelector((state) => state.employeesList);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const onChange = (val, key) => {
    setActiveFilter((prev) => {
      if (!!val) {
        const state = { ...(prev || {}), [key]: val };
        const obj = {
          employeeId: "employeeDepartmentName",
          employeeDepartmentName: "employeeId",
        };
        if (Object.keys(obj).includes(key)) {
          const { [obj[key]]: _, ...rest } = state || {};
          return rest;
        }
        return state;
      } else {
        const { [key]: _, ...rest } = prev || {};
        return rest;
      }
    });
    eventTracker("Liste Prezencat", "click", "Filtered shifts by range");
  };

  return (
    <div className="time-sheet-header-comp" data-testid="timeSheetHeader">
      {viewType !== "user" && (
        <>
          <div className="search-input">
            <Select
              allowClear
              showSearch
              popupClassName={isDarkMode ? "darkDropdown" : ""}
              value={activeFilter?.employeeId || null}
              placeholder="Kërko punonjës"
              data-testid="selectEmployee"
              optionFilterProp="children"
              disabled={viewType === "user" ? true : false}
              onChange={(val) => onChange(val, "employeeId")}
              suffixIcon={<DropDownIcon />}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {activeEmployees.length > 0 && viewType !== "user" ? (
                activeEmployees.map((el, idx) => (
                  <Option
                    key={idx}
                    value={el?.employeeId}
                    data-testid={el?.employeeId}
                  >{`${el?.employeeFirstName} ${el?.employeeLastName}`}</Option>
                ))
              ) : (
                <Option value={auth?.employeeId} key={1}>
                  {auth?.userAccess[0]?.given_name}
                </Option>
              )}
            </Select>
          </div>
          <div className="department-select">
            <Select
              allowClear
              value={activeFilter?.employeeDepartmentName || null}
              showSearch
              popupClassName={isDarkMode ? "darkDropdown" : ""}
              placeholder="Zgjidh Departamentin"
              data-testid="selectDepartment"
              optionFilterProp="children"
              suffixIcon={<DropDownIcon />}
              onChange={(val) => onChange(val, "employeeDepartmentName")}
              disabled={viewType === "user" ? true : false}
            >
              {!!departments &&
                departments?.map((el, idx) => (
                  <Option
                    value={el?.departmentName}
                    data-testid={el?.departmentName}
                    key={idx}
                  >
                    {el?.departmentName + ""}
                  </Option>
                ))}
            </Select>
          </div>
        </>
      )}

      <div className="month-filter-btns">
        <TimeSheetButtonsFilter {...{ activeFilter, setActiveFilter }} />
      </div>
      <div className="filter-date-range">
        <DatePicker
          placeholder="Fillimi"
          value={activeFilter.range?.[0]}
          popupClassName={isDarkMode ? "darkDropdown" : ""}
          onChange={(val) => {
            setActiveFilter((prev) => {
              const [_, end] = prev.range || [];
              let range = [val, end];
              if (end && val && dayjsTZ(val).isAfter(end)) {
                range = [val, null];
              }
              return { ...prev, range };
            });
            eventTracker(
              "Liste Prezencat",
              "click",
              "Filtered shifts by range"
            );
          }}
          allowClear={false}
          format={"DD/MM/YYYY"}
        />
        <DatePicker
          placeholder="Mbarimi"
          value={activeFilter.range?.[1]}
          popupClassName={isDarkMode ? "darkDropdown" : ""}
          onChange={(val) => {
            setActiveFilter((prev) => {
              const [start, _] = prev.range || [];
              let range = [start, val];
              if (start && val && dayjsTZ(val).isBefore(start)) {
                range = [start, null];
                showWarningMsg({
                  content:
                    "Data e mbarimit duhet të jetë pas datës së fillimit.",
                });
              }
              return { ...prev, range };
            });
            eventTracker(
              "Liste Prezencat",
              "click",
              "Filtered shifts by range"
            );
          }}
          allowClear={false}
          format={"DD/MM/YYYY"}
        />
      </div>
      {viewType !== "user" ? (
        <MondayButton
          className="mondayButtonRed"
          testid="pastroFiltrimin"
          onClick={() => setActiveFilter({})}
          disabled={!Object.keys(activeFilter || {}).length}
        >
          Pastro Filtrimin
        </MondayButton>
      ) : null}
    </div>
  );
}

export default TimeSheetHeader;
